import React, { useContext } from 'react';
import HamburgerMenu from 'react-hamburger-menu';
import { GlobalContext } from '@interness/web-core/src/providers';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import { useHeaderData } from '@interness/web-core/src/hooks';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Header = () => {
  const data = useHeaderData();
  const {
    primaryMenuOpen,
    togglePrimaryMenu
  } = useContext(GlobalContext);
  const toggleMenu = () => togglePrimaryMenu(!primaryMenuOpen);
  return ___EmotionJSX(S.Header, null, ___EmotionJSX(S.Container, null, ___EmotionJSX(S.LogoSection, null, ___EmotionJSX(Link, {
    to: "/"
  }, ___EmotionJSX("img", {
    src: data.logo.localFile.publicURL,
    alt: data.seo_title,
    title: data.seo_title
  }))), ___EmotionJSX(S.CartSection, {
    id: "int-cart"
  }), ___EmotionJSX(S.MenuSection, null, ___EmotionJSX("div", {
    "aria-label": "Men\xFC"
  }, ___EmotionJSX(HamburgerMenu, {
    isOpen: primaryMenuOpen,
    menuClicked: toggleMenu,
    strokeWidth: 3,
    borderRadius: 5
  }), ___EmotionJSX("p", {
    style: {
      fontSize: '0.7rem',
      textAlign: 'center',
      marginTop: '5px',
      marginBottom: '0'
    }
  }, "Men\xFC")))));
};
export default Header;